
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legacyandpolicy",
      function () {
        return require("private-next-pages/legacyandpolicy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legacyandpolicy"])
      });
    }
  